import { PROJECT_CONTENT_TAB_TYPE, ProjectContentData } from '../types';
import { tableOfContentTab } from './data';

export const sqrSale: ProjectContentData = {
  id: 'sqr-sale',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'token-sale-details',
      label: 'Token Sale Details',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'sqr',
          value: 'SQR',
          name: 'Token Symbol',
        },
        {
          id: 'sale-start-date',
          value: '25.07.2024',
          name: 'Sale Start Date',
        },
        {
          id: 'sale-end-date',
          value: '26.07.2024',
          name: 'Sale End Date',
        },
        {
          id: 'token-distribution-start',
          value: '26.07.2024',
          name: 'Token Distribution Start',
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$100,000',
          description: <span>Amount to be raised from all pools</span>,
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              Accepted stable coin and network
              <br />
              for IDO participation.
            </span>
          ),
        },
        {
          id: 'discounted-price',
          value: 'The discounted price will be determined on the sale start date',
          name: 'Token Price',
          description: <span>Price for the token sale</span>,
        },
      ],
    },
    {
      id: 'vesting-schedule',
      label: 'Vesting Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'at-end-of-sale',
          value: '25%',
          name: 'At end of Sale',
          description: (
            <span>
              Percentage of tokens
              <br />
              claimable/distributed at the TGE.
            </span>
          ),
        },
        {
          id: 'cliff',
          value: '1 month',
          name: 'Cliff',
          description: (
            <span>
              Months until the next
              <br />
              token distribution post-TGE.
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          name: 'Linear Vesting',
          value: '3 months',
          description: (
            <span>
              Token distribution
              <br />
              schedule post-cliff period.
            </span>
          ),
        },
      ],
    },
  ],
};
